export const useCommunityAnimations = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.3,
        ease: "easeInOut",
      },
    },
  };

  const titleAnimation = {
    hidden: { y: -20, opacity: 0 },
    show: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 20,
      },
    },
  };

  const topItemAnimation = {
    hidden: { y: 30, opacity: 0, scale: 0.95 },
    show: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 20,
      },
    },
    tap: {
      scale: 0.97,
      transition: {
        duration: 0.1,
      },
    },
  };

  const listItemAnimation = {
    hidden: { y: 30, opacity: 0 },
    show: (custom: number) => ({
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 20,
        delay: 0.1 * custom,
      },
    }),
    tap: {
      scale: 0.98,
      backgroundColor: "rgba(255, 255, 255, 0.08)",
      transition: {
        duration: 0.1,
      },
    },
  };

  const listContainerAnimation = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.3,
      },
    },
  };

  const avatarAnimation = {
    hidden: { scale: 0.8, opacity: 0, rotate: -5 },
    show: {
      scale: 1,
      opacity: 1,
      rotate: 0,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 15,
        delay: 0.1,
      },
    },
  };

  return {
    container,
    titleAnimation,
    topItemAnimation,
    listItemAnimation,
    listContainerAnimation,
    avatarAnimation,
  };
};
